import { render, staticRenderFns } from "./PackedCirclesInvestment.vue?vue&type=template&id=5b2c8276&scoped=true&"
import script from "./PackedCirclesInvestment.vue?vue&type=script&lang=js&"
export * from "./PackedCirclesInvestment.vue?vue&type=script&lang=js&"
import style0 from "./PackedCirclesInvestment.vue?vue&type=style&index=0&id=5b2c8276&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2c8276",
  null
  
)

export default component.exports